import * as http from '../../../../../utils/apis';
import transformPerformanceData from '../../../../../services/dashboard/performance.service';

const performanceApi = {
    getAll: async () => {
        const res = await http.get(`cms-api/dashboard/performance`);
        const transformedData = transformPerformanceData(res.data);
        return transformedData;
    },
};

export default performanceApi;
